// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class UnsubscribeBySourceNameRequestModel {
    static getAttributeTypeMap() {
        return UnsubscribeBySourceNameRequestModel.attributeTypeMap;
    }
}
UnsubscribeBySourceNameRequestModel.discriminator = undefined;
UnsubscribeBySourceNameRequestModel.additionalProperties = false;
UnsubscribeBySourceNameRequestModel.attributeTypeMap = [
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
    {
        "name": "sourceName",
        "baseName": "sourceName",
        "type": "string"
    },
];
//# sourceMappingURL=unsubscribeBySourceNameRequestModel.js.map